<cc-box class="contact-note-wrapper">
  <div class="contact-note-header" box header>
    <p class="contact-note-title-text"><span>{{'EVENT_DETAILS.NOTE' | translate}}</span></p>
  </div>
  <div class="box-content contact-note-content" box content>
    <form class="contact-note-form" novalidate>
    <textarea rows="3" class="contact-note-form-input"
              [formControl]="note" maxlength="255"
              [placeholder]="'EVENT_DETAILS.ADD_NEW_NOTE' | translate" required></textarea>
      <small class="contact-note-form-error" *ngIf="note.touched && note.hasError('required')">
             {{'REQUIRED_FIELD_MESSAGE' | translate}}</small>
      <div class="contact-note-form-submit">
        <button class="contact-note-form-submit-button btn channels-button info-full" type="submit"
                (click)="save()" [disabled]="note.invalid"
                translate="ADD"></button>
      </div>
    </form>
  </div>
</cc-box>
